import { motion } from 'framer-motion';
import { Sparkles, Brain, MessageSquare, Target, Users, TrendingUp } from 'lucide-react';

const features = [
  {
    icon: Sparkles,
    title: 'Self-Perception',
    description: 'See what your imagination says about how you view yourself, your boundaries, confidence, and inner strength.'
  },
  {
    icon: Brain,
    title: 'Ambition',
    description: 'Discover how you pursue your goals and the role ambition plays in your life.'
  },
  {
    icon: MessageSquare,
    title: 'Relationships',
    description: 'Gain insight into how you connect with romantic partners, from trust and closeness to freedom.'
  },
  {
    icon: Target,
    title: 'Care & Connection',
    description: 'Reveal who or what you nurture, and what this says about your relationship with those you care for.'
  },
  {
    icon: Users,
    title: 'Vulnerability',
    description: 'Understand how you respond to stress, change, and emotional challenges.'
  },
  {
    icon: TrendingUp,
    title: 'Your Inner World',
    description: 'This test brings everything together, creating a brief yet strikingly accurate reflection of your inner world.'
  }
];

export default function FeaturesGrid() {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 border-t border-[#e4e1d8]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <h2 className="font-serif font-medium text-3xl sm:text-4xl text-[#1d1f24] mb-3">
            What you&apos;ll discover
          </h2>
          <p className="text-lg text-[#5d606a] max-w-2xl">
            Uncover what your imagination reveals, with insights interpreted from the original Kariton Cube Test.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              className="group"
            >
              <div className="h-full bg-white border border-[#e4e1d8] rounded-xl p-7 shadow-[0_10px_24px_rgba(29,31,36,0.05)] hover:border-[#c43b3b]/40 transition-colors duration-300">
                <div className="mb-5">
                  <div className="w-12 h-12 bg-[#f7f6f2] border border-[#e4e1d8] rounded-xl flex items-center justify-center">
                    <feature.icon className="w-6 h-6 text-[#c43b3b]" />
                  </div>
                </div>
                <h3 className="font-serif text-xl text-[#1d1f24] mb-2">{feature.title}</h3>
                <p className="text-sm text-[#5d606a] leading-relaxed">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
